import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

export type WhapiGroup = {
    id: string;
    name: string;
    memberCount: number;
};

export const GET_WHAPI_GROUPS_QUERY_KEY = (organizationId: string) =>
    ['organization', organizationId, 'whapiGroups'];

export const useGetWhapiGroups = (organizationId: string, enabled: boolean) => {
    const apiClient = useApiClient();

    return useQuery<WhapiGroup[]>({
        queryKey: GET_WHAPI_GROUPS_QUERY_KEY(organizationId),
        queryFn: () =>
            apiClient.fetchApi<WhapiGroup[], {}>({
                method: 'GET',
                endpoint: `organizations/${organizationId}/whapi-groups`,
            }),
        enabled: !!organizationId && enabled,
    });
};
